import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const softwareListing = async (page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.softwareList, {
    page,
    limit,
  });
  return response.data;
};

export const solutionListing = async (page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.solutionsList, {
    page,
    limit,
  });
  return response.data;
};


export const resourceListing = async () => {
  const response = await apiService.get(apiRoutes.resources);
  return response.data;
};

export const recommendedResourceListing = async (id) => {
  const response = await apiService.get(`${apiRoutes.recommendedResources}?id=${id}`);
  return response.data;
};

export const categoryAllResourceListing = async (id, page = 1, limit = 9) => {
  const response = await apiService.get(`${apiRoutes.categoryAllResourceListing}?id=${id}&page=${page}&limit=${limit}`);
  return response.data;
};

export const getResourceDetails = async (id) => {
  const response = await apiService.get(`${apiRoutes.resourceDetails}?id=${id}`);
  return response.data;
};

export const getCategoryBySlug = async (category,slug) => {
  const response = await apiService.get(`${apiRoutes.getCategoryBySlug}?type=${category}&slug=${slug}`);
  return response.data;
};

export const getPopularSoftSolList = async () => {
  const response = await apiService.get(apiRoutes.popularSoftSolList);
  return response.data;
};